
import { Mixins, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { Reaction } from '@padlet/arvo'

const reaction = namespace('reaction')
const snackbars = namespace('snackbars')

@Component({ components: { OzIcon } })
export default class SurfacePostReactionVoteNew extends Mixins() {
  @Prop({ required: true }) reactionIds!: string[]
  @Prop({ required: true }) myReactionId!: string | undefined
  @Prop({ required: true }) isPadletColorSchemeDark!: boolean
  @Prop({ required: true }) canReact!: boolean
  @Prop({ default: 'postView' }) usageContext!: 'postView' | 'postExpandedView'

  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean
  @reaction.Getter getReactionById!: (id) => Reaction | undefined

  get isUsedInPostExpandedView(): boolean {
    return this.usageContext === 'postExpandedView'
  }

  get iconSize(): number {
    return this.isUsedInPostExpandedView ? (this.isSmallerThanTabletPortrait ? 24 : 20) : 18
  }

  get upvoteCount(): number {
    return this.reactionIds.filter((id) => (this.getReactionById(id) as Reaction).value === 1).length
  }

  get downvoteCount(): number {
    return this.reactionIds.filter((id) => (this.getReactionById(id) as Reaction).value === -1).length
  }

  get currentUserUpvoted(): boolean {
    return !!this.myReactionId && (this.getReactionById(this.myReactionId) as Reaction).value === 1
  }

  get currentUserDownvoted(): boolean {
    return !!this.myReactionId && (this.getReactionById(this.myReactionId) as Reaction).value === -1
  }

  get voteClasses(): string[] {
    const classes = ['flex', 'flex-row', this.isUsedInPostExpandedView ? 'items-center' : 'items-end']
    if (this.canReact) {
      classes.push('cursor-pointer')
    }

    if (this.isPadletColorSchemeDark) {
      classes.push(
        'text-light-text-200',
        'hover-hover:hover:text-light-text-100',
        'hover-hover:focus:text-canary-500',
        'hover-hover:active:text-canary-500',
      )
    } else {
      classes.push(
        'text-dark-text-200',
        'hover-hover:hover:text-dark-text-100',
        'hover-hover:focus:text-grape-500',
        'hover-hover:active:text-grape-500',
      )
    }

    return classes
  }

  @snackbars.Action setSnackbar!: (payload: { message: string }) => void

  publishReaction(value): void {
    this.$emit('create', value)
  }

  removeReaction(): void {
    this.$emit('delete')
  }

  showReactionOffNotice(): void {
    const message = this.__('Reactions have been disabled by the admin.')
    this.setSnackbar({ message })
  }

  toggleVote(isUpvote: boolean): void {
    if ((isUpvote && this.currentUserUpvoted) || (!isUpvote && this.currentUserDownvoted)) {
      this.removeReaction()
    } else if (this.canReact) {
      this.publishReaction(isUpvote ? 1 : -1)
    } else {
      this.showReactionOffNotice()
    }
  }

  toggleUpvote(): void {
    this.toggleVote(true)
  }

  toggleDownvote(): void {
    this.toggleVote(false)
  }
}
